import React, { useContext, useEffect, useState } from "react";
import { apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiOutlineHistory } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty, startCase } from "lodash";
import helper from "../../utils/helpers";
import { Link, NavLink } from "react-router-dom";
import OButton from "components/reusable/OButton";
import { Input, TextField } from "@mui/material";

const ProjectTable = ({
  paginationObj,
  sort,
  setSort,
  list,
  fetchProjects,
  manager,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const [selectedProject, setSelectedProject] = useState([]);
  const [selctAllCheck, setSelectAllCheck] = useState(false);
  const [presentationUrl, setPresentationUrl] = useState(false);
  const [showAddModal, setAddModal] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.ChangeStatusProjects}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchProjects();
      }
    } catch (error) {
      console.log("error in get all sub admin list==>>>>", error.message);
    }
  };
  const selectHandler = (data) => {
    const isExists = selectedProject?.find((res) => res?._id === data?._id);
    if (!isExists) {
      setSelectedProject([...selectedProject, data]);
    } else {
      setSelectedProject(
        selectedProject.filter((item) => item?._id !== data?._id),
      );
    }
  };

  useEffect(() => {
    if (selectedProject?.length !== list?.length) {
      setSelectAllCheck(false);
    }
  }, [selectedProject]);

  useEffect(() => {
    setPresentationUrl("");
  }, [showAddModal]);

  const selctAllHandler = () => {
    setSelectAllCheck(!selctAllCheck);
    if (selectedProject?.length === list?.length) {
      setSelectedProject([]);
    } else setSelectedProject(list?.map((res) => res));
  };

  const addProposal = async () => {
    if (!selectedProject?.length) {
      notification.error(t("PLEASE_ENTER_AT_LEAST_ONE_PROJECT"));
      return;
    }
    setAddModal(!showAddModal);
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("✅ Copied successfully ");
    } catch (e) {
      console.log("❌ Failed to copy (insufficient permissions) ");
    }
  };

  const createProposalHandler = async () => {
    try {
      if (!customerName?.trim()) {
        notification.error("Please enter customer name");
        return;
      }
      let payload = [];
      selectedProject.forEach((element) => {
        payload.push({ projectId: element?._id });
      });

      const path = apiPath.projectPresentation;
      const result = await apiPost(path, { projects: payload, customerName });
      if (result?.status === 200) {
        notification.success(result.data.message);
        setPresentationUrl(result?.data?.results?.url);
        fetchProjects();
        // setAddModal(false);
        // setSelectedProperty([]);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };
  return (
    <>
      <div className="p-3">
        <div className="flex items-center">
          <button
            onClick={() => addProposal()}
            type="button"
            class="bg-[#8FC150] text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
          >
            + {t("CREATE_PROJECT_PROPOSAL")}
          </button>
        </div>
        <div className="overflow-x-auto relative border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  <input
                    type="checkbox"
                    id="check"
                    name="selectAll"
                    checked={selctAllCheck}
                    onChange={() => selctAllHandler()}
                  />
                </th>
                <th scope="col" className="py-3 px-6">
                  #
                </th>

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() =>
                    setSort({
                      sortKey: "name",
                      sortType:
                        sort.sortKey === "name" && sort.sortType === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <div className="flex">
                    <span>{t("PROJECT_ID")} </span>
                    <span>
                      {sort.sortKey === "name" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "name" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() =>
                    setSort({
                      sortKey: "name",
                      sortType:
                        sort.sortKey === "name" && sort.sortType === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <div className="flex">
                    <span>{startCase(t("O_PROJECT"))} </span>
                    <span>
                      {sort.sortKey === "name" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "name" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_PROJECT") + t("O_ARABIC")}
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "property_type" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "property_type",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "property_type",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_CATEGORY")} </span>
                    <span>
                      {sort.sortKey === "name" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "name" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STARTING_PRICE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_PROPERTY_SIZE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STATUS")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_CONSTRUCTION_STATUS")}
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "createdAt" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_CREATED_AT")}</span>
                    <span>
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "createdAt" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_UPDATED_AT")}</span>
                    <span>
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                {(manager?.add || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTIVE_DE_ACTIVE")}
                  </th>
                )}
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list?.map((item, i) => (
                  <tr
                    key={i}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      <input
                        type="checkbox"
                        id="check"
                        name="project"
                        value={item?._id}
                        checked={selectedProject.find(
                          (res) => res?._id === item?._id,
                        )}
                        onChange={() => selectHandler(item)}
                      />
                    </th>
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className="py-2 px-2 border-r">
                      {item.projectId ? item.projectId : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r text-DarkBlue">
                      <a
                        href={`${process.env.REACT_APP_WEBSITE_BASE_URL}/project/${item.slug}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item?.title}
                      </a>
                    </td>
                    <td className="py-2 px-2 border-r">{item?.titleAr}</td>
                    <td className="py-2 px-2 border-r">
                      {item?.propertyCategory
                        ? item?.propertyCategory
                            ?.map((property) => startCase(property.name))
                            .join(", ") + "."
                        : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.startingPrice}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {`Min-${item?.minPropertySize} Max-${
                        item?.maxPropertySize ?? "N/A"
                      }`}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {startCase(item?.projectStatus)}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.constructionStatus ?? "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {helper.dateFormat(item?.createdAt)}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {helper.dateFormat(item?.updatedAt)}
                    </td>
                    {(manager?.add || user?.role === "admin") && (
                      <td className="py-2 px-2 border-r text-center">
                        <label
                          className="inline-flex relative items-center cursor-pointer"
                          // title={t('O_STATUS')}
                          title={`${
                            item?.status === "active" ? "Active" : "Inactive"
                          }`}
                        >
                          <input
                            type="checkbox"
                            // value={status}
                            className="sr-only peer"
                            checked={item?.status === "active"}
                            onChange={(e) =>
                              helper.alertFunction(
                                `Are you sure want to ${
                                  e.target.checked ? "active" : "inactive"
                                } ${item.title}?`,
                                item,
                                handelStatusChange,
                              )
                            }
                            // onChange={(e) => handelStatusChange(item)(e)}
                          />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                        </label>
                      </td>
                    )}
                    <td className="py-4 px-6 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink to="/projects/viewNew" state={{ item }}>
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                            </NavLink>
                          </li>
                          {(manager?.add || user?.role === "admin") && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <Link
                                title={t("O_EDIT_PROJECT")}
                                to={`/projects/edit-project/${item._id}`}
                                state={{ item }}
                              >
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </Link>
                            </li>
                          )}
                          {user?.role === "admin" && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <Link
                                title="History"
                                to={`/projects/history/${item._id}`}
                                state={{ item }}
                              >
                                <AiOutlineHistory className="cursor-pointer w-5 h-5 text-slate-600" />
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6" colSpan={12}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showAddModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      Create Project Presentation
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => {
                        setCustomerName("");
                        setSelectedProject([]);
                        setPresentationUrl(false);
                        setAddModal(!showAddModal);
                      }}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="m-3">
                    <TextField
                      label="Customer Name"
                      type="text"
                      placeholder="Customer Name"
                      className="w-full"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                      size="small"
                    />
                  </div>
                  <div
                    className="overflow-x-auto relative 
 border m-3"
                  >
                    <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                      <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="py-3 px-6">
                            <div className="flex">
                              <span>{t("O_PROJECT")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("PROJECT_ID")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6  ">
                            <div className="flex">
                              <span>{t("O_PROPERTY_CATEGORY")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_STARTING_PRICE")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_PROPERTY_SIZE")} </span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProject &&
                          selectedProject?.map((item) => {
                            return (
                              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                <th
                                  key={item?._id}
                                  scope="row"
                                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                                >
                                  {item?.title}
                                </th>
                                <td className="py-2 px-2 border-r">
                                  {item.projectId ? item.projectId : "N/A"}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertyCategory
                                    ? item?.propertyCategory
                                        ?.map((property) =>
                                          startCase(property.name),
                                        )
                                        .join(", ") + "."
                                    : "N/A"}
                                </td>

                                <td className="py-2 px-2 border-r">
                                  {item?.startingPrice}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {`Min-${item?.minPropertySize} Max-${
                                    item?.maxPropertySize ?? "N/A"
                                  }`}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {presentationUrl && (
                    <div className="flex items-center justify-between p-5 rounded-t">
                      <p className="text-s font-semibold">
                        Project Presentation link:
                        <Link
                          to={presentationUrl}
                          target="_blank"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            fontSize: 14,
                          }}
                        >
                          {`${presentationUrl}`}
                        </Link>
                      </p>
                      <div className="col-2 text-center ml-5">
                        <OButton
                          label={<>{t("COPY_URL")} </>}
                          type="button"
                          onClick={() => copyToClipboard(presentationUrl)}
                        />
                      </div>
                    </div>
                  )}

                  {!presentationUrl && (
                    <div className="col-2 text-center mb-5">
                      <OButton
                        label={<>{t("CREATE")} </>}
                        type="button"
                        onClick={() => createProposalHandler()}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}
    </>
  );
};

export default ProjectTable;
